module.exports = "/_next/static/images/namecoin-0d929f1fe1f48cf5ec9c3a435f3a9c6a.png";